// MR-C — send a delivered working to the Cauldron. Reused on every Magic Room surface.
// 14-B7b: `language` is REQUIRED here (14-B6a's ruling on ResultDestinations), because this control
// is on eleven surfaces and an optional prop nobody passes is R27's live defect. The TYPE finds the
// call site that forgets it; a default would have left ten Spanish rooms with an English button.
//
// R216: EXTRACTED FROM `src/App.tsx`, where the ONE control that carries a paid working to the pot
// from eleven surfaces could be reached by nothing but a regex over twelve thousand lines. It holds
// two hooks, so a gate cannot CALL it the way `r7-components.mjs` calls a leaf — the reach it buys
// is the IMPORT (`SignInModal`'s own precedent, L10). What that import makes checkable is the half
// this control's own comments have twice been about: the REQUIRED `language`, and R26-2's door to
// where the working landed, which existed on the one surface that does not share this sender and
// therefore on none of the nine that do.
import { useState } from "react";
import { sendToCauldron, cauldronSendNote, cauldronSendState } from "../lib/cauldron-send";
import { GoToCauldronButton } from "./CauldronDoor";
import { t } from "../strings.js";

export function SendToCauldronButton({ kind, title, data, disabled, language }: { kind: string; title: string; data: unknown; disabled?: boolean; language: string }) {
  const [state, setState] = useState<"idle" | "sending" | "sent" | "error">("idle");
  const [note, setNote] = useState("");
  async function send() {
    setState("sending"); setNote("");
    // R50: one transport, two surfaces. The ANSWER decides the state and the sentence, never the
    // status code — `handleCauldronAdd` refuses at HTTP 200 with `{ ok: false }` (R47's defect).
    const answer = await sendToCauldron({ kind, title, data });
    setState(cauldronSendState(answer));
    setNote(cauldronSendNote(answer, { signIn: t(language, "cauldron.sendSignIn"), failed: t(language, "cauldron.sendFailed") }));
  }
  return (
    <>
      <button type="button" className="button button--ghost" onClick={send} disabled={disabled || state === "sending" || state === "sent"}>
        {t(language, state === "sent" ? "cauldron.sent" : state === "sending" ? "cauldron.sending" : "cauldron.send")}
      </button>
      {/* R26-2 (OV2-7's own sentence, made true): once it lands, the door to where it landed. This is
          the SHARED sender — the journal, the spell page, oils, Moses, the Greater Keys, herbs, the
          notepaper and the petition all send through it — and every one of them used to stop at
          "✓ In the Cauldron" and leave her to find the pot herself. The trip was hand-wired at the one
          surface that does NOT share this sender (the seal choice-list), which is exactly why the
          other nine went without. It lives here now, so sending IS how a surface gets it. */}
      {state === "sent" ? <GoToCauldronButton className="button button--ghost" language={language} /> : null}
      {note ? <span className="find-your-type__status">{note}</span> : null}
    </>
  );
}
